// extracted by mini-css-extract-plugin
export default {"button":"qq-z","reviewSort":"rq-z"};